export { default as wishlists } from './wishlists';
